"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionSummaryStore = void 0;
var services_1 = require("../services");
var CollectionSummaryStore = /** @class */ (function () {
    function CollectionSummaryStore() {
    }
    CollectionSummaryStore.prototype.get = function (revision) {
        var rest = services_1.Services.Department.rest;
        return rest.CollectionSummary.getByRevision(revision).value;
    };
    CollectionSummaryStore.prototype.getLatest = function (revision) {
        var rest = services_1.Services.Department.rest;
        var summary = rest.CollectionSummary.getByRevision(revision).value;
        if (summary == null) {
            return null;
        }
        var latestSummary = rest.CollectionSummary.getByUuid(summary.uuid).value;
        if (latestSummary == null) {
            return null;
        }
        return latestSummary;
    };
    CollectionSummaryStore.prototype.fetch = function (revision) {
        var rest = services_1.Services.Department.rest;
        return rest.CollectionSummary.getByRevision(revision).fetch();
    };
    CollectionSummaryStore.prototype.getFetchableByUuid = function (uuid) {
        var rest = services_1.Services.Department.rest;
        return rest.CollectionSummary.getByUuid(uuid);
    };
    return CollectionSummaryStore;
}());
exports.CollectionSummaryStore = CollectionSummaryStore;
//# sourceMappingURL=collection.summary.store.js.map